module.exports = __webpack_public_path__ + "media/images/boxes/seo-girl-c1ca5ecee31ce0e88b52135f213e5b06.jpg";